/**
 * Three evenly-spaced stat cells: streak + comment cap + repost cap.
 * Replaces the old StreakFlame + CapsRing pair which fought justify-between
 * and left tooltip icons floating loose.
 */
export default function StatGrid({ streak = 0, caps }) {
  const lit = streak > 0
  const commentLimit = caps?.comment.limit || 5
  const commentLeft = Math.max(0, commentLimit - (caps?.comment.used || 0))
  const repostLimit = caps?.repost.limit || 3
  const repostLeft = Math.max(0, repostLimit - (caps?.repost.used || 0))

  return (
    <div className="grid grid-cols-3 gap-2">
      <Cell
        visual={
          <span
            className={`text-2xl ${lit ? 'animate-flame-flicker drop-shadow-[0_0_8px_rgba(248,170,27,0.6)]' : 'grayscale opacity-40'}`}
            aria-hidden="true"
          >
            🔥
          </span>
        }
        value={streak}
        label="Day streak"
      />
      <Cell
        visual={<Ring used={caps?.comment.used || 0} limit={commentLimit} colour="#3076E2" />}
        value={commentLeft}
        suffix={`/${commentLimit}`}
        label="Comments left"
      />
      <Cell
        visual={<Ring used={caps?.repost.used || 0} limit={repostLimit} colour="#1D3557" />}
        value={repostLeft}
        suffix={`/${repostLimit}`}
        label="Reposts left"
      />
    </div>
  )
}

function Cell({ visual, value, suffix, label }) {
  return (
    <div className="flex flex-col items-center text-center gap-1.5 px-1">
      <div className="h-11 flex items-center justify-center">
        {visual}
      </div>
      <div className="leading-none">
        <span className="text-lg font-bold text-brand-text">{value}</span>
        {suffix && <span className="text-xs text-brand-text-muted ml-0.5">{suffix}</span>}
      </div>
      <div className="text-[10px] uppercase tracking-wider text-brand-text-muted">
        {label}
      </div>
    </div>
  )
}

function Ring({ used, limit, colour }) {
  const pct = Math.min(100, Math.round((used / limit) * 100))
  const radius = 18
  const circ = 2 * Math.PI * radius
  const offset = circ * (1 - pct / 100)
  return (
    <svg width="44" height="44" viewBox="0 0 44 44" className="-rotate-90">
      <circle cx="22" cy="22" r={radius} fill="none" stroke="#E0E1E3" strokeWidth="4" />
      <circle
        cx="22" cy="22" r={radius} fill="none"
        stroke={colour} strokeWidth="4"
        strokeDasharray={circ}
        strokeDashoffset={offset}
        strokeLinecap="round"
        style={{ transition: 'stroke-dashoffset 600ms cubic-bezier(0.34, 1.56, 0.64, 1)' }}
      />
    </svg>
  )
}
